<script lang="ts">
	import { onMount } from 'svelte';
	import Navbar from './Navbar.svelte';
	import Button from '$lib/components/Button.svelte';
	import LucideLightbulb from '~icons/lucide/lightbulb';

	let theme: 'light' | 'dark' = $state('dark');

	const setTheme = (newTheme: 'light' | 'dark') => {
		// We're doing all of this since a smooth transition is more desireable
		// than a flicker when the theme changes.
		document.documentElement.classList.add('!transition-colors', '!duration-150', '!ease-out');
		document.documentElement.setAttribute('data-theme', newTheme);
		localStorage.setItem('theme', newTheme);
		setTimeout(() => {
			document.documentElement.classList.remove('!transition-all', '!duration-150', '!ease-out');
		}, 300);
	};

	onMount(() => {
		// Check if the user has a theme preference in localStorage
		// If not, default to the system preference
		const storedTheme =
			(localStorage.getItem('theme') as 'light' | 'dark' | null) ??
			(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
		theme = storedTheme;
		setTheme(theme);
	});

	function toggleTheme() {
		theme = theme === 'light' ? 'dark' : 'light';
		setTheme(theme);
	}
</script>

<nav
	class="fixed right-0 bottom-0 left-0 z-50 mx-auto my-2 flex w-fit max-w-full gap-2 rounded-xl border-2 border-gray-300 bg-gray-100/65 px-2 py-1 drop-shadow-2xl backdrop-blur-sm sm:gap-4 sm:px-4 sm:py-2 dark:border-gray-600 dark:bg-gray-800/65"
>
	<Navbar />
	<Button onclick={toggleTheme} color="transparent">
		<LucideLightbulb class="h-6 w-6" />
		<span class="sr-only">Toggle Theme</span>
	</Button>
</nav>

<style lang="postcss">
</style>
